package com.patronat.top.features.usermanagement.domain.models

enum class UserStatus {
    ACTIVE,
    INACTIVE;

    fun getLabel(): String {
        return when (this) {
            ACTIVE -> "Активний"
            INACTIVE -> "Неактивний"
        }
    }
}